module.exports = __webpack_public_path__ + "static/media/dwt-09.21c59093.jpg";